import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { HelpdeskView, canSeeHelpdesk, helpdeskSearchShape } from "../../components/helpdesk";
import { LifebuoyIcon } from "../../components/icons/sidebar-icons";
import { ModulePlaceholder } from "../../components/modules/module-placeholder";
import { useDefaultGamesId } from "../../lib/competition/games";

/**
 * `/incident-helpdesk` — the T menu's Incident Helpdesk, Sector 4, for
 * everyone (user, 2026-10-29). Whoever may use the M11 helpdesk (admins,
 * `helpdesk.handle`, `helpdesk.report`) gets it here, the same view as
 * Accommodation's Helpdesk tab; everyone else gets "Coming soon" until the
 * general incident helpdesk exists. The API decides every row either way.
 */
export const Route = createFileRoute("/_app/incident-helpdesk")({
	validateSearch: z.object(helpdeskSearchShape),
	component: IncidentHelpdeskPage,
});

function IncidentHelpdeskPage() {
	const { session } = Route.useRouteContext();
	if (!canSeeHelpdesk(session)) return <ModulePlaceholder messageKey="incidentHelpdesk.message" icon={LifebuoyIcon} />;
	return <Helpdesk />;
}

function Helpdesk() {
	const { session } = Route.useRouteContext();
	const search = Route.useSearch();
	const navigate = Route.useNavigate();
	const gamesId = useDefaultGamesId(search.games_id);
	if (!gamesId)
		return (
			<div className="grid gap-[0.75rem]" aria-busy>
				<div className="skeleton h-[3rem] rounded-[0.625rem]" />
				<div className="skeleton h-[12rem] rounded-[0.625rem]" />
			</div>
		);
	return <HelpdeskView session={session} gamesId={gamesId} search={search} navigate={navigate} />;
}
